import stylesheet from './CardGridInfoTile.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

class NXTCardGridInfoTile extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('info-tile');
        element.innerHTML = `
            <div class="image"><slot name="image"></slot></div>
            <div class="label">
                <slot name="title"></slot>
                <slot name="subtitle"></slot>
            </div>
        `;
        return element;
    }
}

customElements.define('nxt-card-grid-info-tile', NXTCardGridInfoTile);
